import React from 'react';
import { steps } from '../data/siteContent';

const HowItWorksSection: React.FC = () => {
  return (
    <section id="how-it-works" className="section-y">
      <div className="shell">
        <header className="max-w-xl">
          <p className="kicker-action">How it works</p>
          <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[3rem]">
            Four beats. Then the book.
          </h2>
          <p className="prose-note mt-6">No onboarding maze. Everything below is optional except step three.</p>
        </header>

        <ol className="mt-14 grid list-none gap-px bg-ink/12 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <li key={step.chapter} className="bg-background p-7 sm:p-8">
              <span
                className="font-display text-[2.5rem] leading-none text-primary/25"
                aria-hidden="true"
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <p className="kicker mt-5">Chapter {step.chapter}</p>
              <h3 className="display-sm mt-2 text-xl">{step.title}</h3>
              <p className="prose-note mt-3 text-[0.9375rem]">{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorksSection;
